import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 41,
	viewBox: "0 0 40 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			y: .900391,
			width: 40,
			height: 40,
			rx: 20,
			fill: "#E7ECEF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.75,
			y: 15.2217,
			width: 16.5,
			height: 13.9286,
			rx: 3.25,
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12.2861,
			y1: 19.5078,
			x2: 27.7147,
			y2: 19.5078,
			stroke: "black",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 14.9639,
			y1: 12.9004,
			x2: 14.9639,
			y2: 15.4718,
			stroke: "black",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 25.25,
			y1: 12.9004,
			x2: 25.25,
			y2: 15.4718,
			stroke: "black",
			strokeWidth: 1.5
		})
	]
});
export default SvgCalendarIcon;
